import { safeTrackerFactory } from '../../core/tracker-factory';
import { createRuntimeTracker, type RuntimeTrackerOptions } from '../shared';
import { BrowserNetwork } from './browser-network';
import { BrowserStorage } from './browser-storage';
import {
  browserClickCapturePlugin,
  type ClickCaptureOptions,
} from './click-capture-plugin';
import {
  browserPageViewPlugin,
  type PageViewOptions,
} from './page-view-plugin';
import { browserUnloadFlushPlugin } from './unload-flush-plugin';
import { browserSystemPlugin } from './browser-system-plugin';

export interface BrowserTrackerOptions extends RuntimeTrackerOptions {
  autoPageView?: boolean | PageViewOptions;
  autoClick?: boolean | ClickCaptureOptions;
  /** 传 false 可禁用浏览器系统环境采集（_shopCart 将回退为 systemDefaults 的默认值） */
  system?: false;
}

export function createBrowserTracker(options: BrowserTrackerOptions) {
  return safeTrackerFactory((retain) => {
    options = { ...options };

    const {
      autoPageView = false,
      autoClick = false,
      ...runtimeOptions
    } = options;

    const tracker = retain(createRuntimeTracker(runtimeOptions, {
      storage: options.storage ?? new BrowserStorage(),
      network: options.network ?? new BrowserNetwork(),
    }));

    if (options.system !== false) {
      tracker.use(browserSystemPlugin());
    }

    if (autoPageView) {
      tracker.use(browserPageViewPlugin(
        typeof autoPageView === 'object' ? autoPageView : undefined
      ));
    }
    if (autoClick) {
      tracker.use(browserClickCapturePlugin(
        typeof autoClick === 'object' ? autoClick : undefined
      ));
    }
    if (options.autoFlushOnUnload) {
      tracker.use(browserUnloadFlushPlugin());
    }

    return tracker;
  });
}
